'use client';

import type { SelfDescribingJson } from '@snowplow/browser-tracker';
import { createContext, useContext, useMemo } from 'react';

import type { TrackingContextsProviderProps } from './use-tracking-contexts.types';

const TrackingContexts = createContext<SelfDescribingJson[]>([]);

export const useTrackingContexts = () => useContext(TrackingContexts);

/**
 * Use TrackingContextsProvider to provide tracking contexts down the
 * react tree to client components.
 *
 * It merges contexts from other TrackingContextsProvider´s up in the components tree.
 */
export function TrackingContextsProvider({
  children,
  contexts,
}: TrackingContextsProviderProps): JSX.Element {
  const parentContexts = useTrackingContexts();

  const value = useMemo(
    () => [...parentContexts, ...contexts],
    [contexts, parentContexts],
  );

  return (
    <TrackingContexts.Provider value={value}>
      {children}
    </TrackingContexts.Provider>
  );
}
